export const loadScriptByUrl = (url: string, async?: boolean): Promise<void> => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    if (async) {
      script.async = async;
    }
    script.onload = () => resolve();
    script.onerror = () => reject();
    document.body.appendChild(script);
  });
};
